<script>
    // #ifdef APP
    import { getReadFileManage, getWriteFileManage } from './utils/public.js';
    // #endif
    import { usePublicStore } from './stores/public.js';
    export default {
        globalData: {
            rootFontSize: '16px'
        },
        onLaunch: async function () {
            const publicStore = usePublicStore();
            const deviceCode = await publicStore.getDeviceCode();
            uni.webView?.getEnv?.(function (res) {
                getApp().globalData.platform = res;
            });
            console.log('这是更新后的ID', deviceCode);
            // #ifdef APP-PLUS
            plus.runtime.getProperty(plus.runtime.appid, function (widgetInfo) {
                usePublicStore().setSystemInfo({
                    appVersion: widgetInfo?.version || '-',
                    // deviceCode: uni.getSystemInfoSync().deviceId
                    deviceCode: deviceCode
                });
            });
            console.log('App Launch');
            this.checkAuth();
            // 网络连接
            publicStore.initNetworkListener();
            // #endif
            //  web 后台与收银台互转代码
            // #ifdef H5
            if (window) {
                usePublicStore().setSystemInfo({
                    appVersion: import.meta.env.VITE_WEB_VERSION,
                    // deviceCode: uni.getSystemInfoSync().deviceId
                    deviceCode: deviceCode
                });
                // h5端网络连接状态检查
                const checkNetworkStatus = () => {
                    if (navigator.onLine) {
                        publicStore.isOfflineH5 = false; // 在线状态
                    } else {
                        publicStore.isOfflineH5 = true; // 离线状态
                        uni.$emit('showToast', {
                            title: '网络已断开',
                            type: 'none',
                            duration: 1000
                        });
                    }
                };

                // 启动时主动检查一次网络状态
                checkNetworkStatus();

                // 监听网络状态变化
                window.addEventListener('online', () => {
                    publicStore.isOfflineH5 = false; // 在线状态
                });

                window.addEventListener('offline', () => {
                    publicStore.isOfflineH5 = true; // 离线状态
                    uni.$emit('showToast', {
                        title: '网络已断开',
                        type: 'none',
                        duration: 1000
                    });
                });
            }
            // #endif
        },
        onShow: function () {
            console.log('App Show');
            // #ifdef APP-PLUS
            const publicStore = usePublicStore();
            // plus.navigator.setFullscreen(true); // 全局隐藏状态栏
            if (publicStore.appHide == 2) {
                publicStore.appHide = 3;
            }
            // #endif
        },
        onHide: function () {
            // #ifdef APP-PLUS
            const publicStore = usePublicStore();
            publicStore.appHide = 2;
            // #endif
            console.log('App Hide');
        },
        methods: {
            async checkAuth() {
                // this.getMac(); //获取mac地址
                await getWriteFileManage();
                await getReadFileManage();
            }
        }
    };
</script>

<style lang="scss">
    // 字体图标库
    @import '@/iconfont/iconfont.css';

    .content-Cont {
        display: inline-flex;
        flex: 1;
        width: 100%;
        overflow: hidden;
        margin-bottom: 20px;
        .content-left-cont {
            flex: 1;
            margin: 0 20px;
            border-radius: 8px;
            overflow: hidden;
        }
        .content-right-Tools {
            width: 184px;
            height: 100%;
            margin: 0px 24px 24px 0;
            overflow: hidden;
        }
    }
    // 统一按钮用的样式，高度和行高等
    .sub-btn {
        background: #d99e4c;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        line-height: 45px;
        max-width: 184px;
        height: 45px;
        text-align: center;
    }
    // 桌台操作按钮用的样式
    .door-action-btn {
        margin-top: 12px;
        margin-bottom: 16px;
        font-size: 24px;
        color: #c38631;
        text-align: center;
        line-height: 60px;
        height: 60px;
        font-weight: 600;
        border-radius: 8px 8px 8px 8px;
        border: 2px solid #c38631;
    }
    // 桌台弹开的布局
    .door-open {
        border-radius: 8px 8px 8px 8px;
        background-color: #fff;
        min-width: 550px;
        width: fit-content;
        .door-line-item {
            margin: 30px 15px 20px 50px;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 20px;
            > text:first-child {
                width: 90px;
                text-align: right;
                //    text-align-last: justify;
                margin-right: 16px;
                padding-right: 12px;
                font-size: 22px;
                position: relative;
                &::after {
                    content: ':';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0;
                }
            }
            > view {
                width: calc(100% - 126px);
            }
        }
        .door-btn-box {
            margin-top: 24px;
            display: flex;
            justify-content: flex-end;
            .door-btn {
                width: 120px;
                margin: 0 12px 16px;
                border-radius: 10px;
                font-size: 20px;
                text-align: center;
                &.cancle {
                    box-sizing: border-box;
                    background: white;
                    color: #828282;
                    border: 2px solid #828282;
                }
            }
        }
    }
    // 这个是z-paging全局的
    .paging-card {
        height: calc(100% - 32px) !important;
        width: calc(100% - 32px) !important;
        padding: 16px;
        background: #fff;
    }

    // 大全屏
    .change-open-box {
        width: 100vw;
        height: 100vh;
        background: transparent;
        display: flex;
        justify-content: center;
        .change-open {
            width: calc(100% - 168px - 184px - 24px - 20px - 40px + 20px);
            height: calc(100% - 64px - 24px - 20px);
            margin: 88px 42px 0 0px;
            display: flex;
            padding: 0px;
            overflow: hidden;
            flex-direction: column;
            display: flex;
            padding: 0px;
            overflow: hidden;
            flex-direction: column;
            &.change-open-right {
                width: calc(100% - 168px - 32px);
                height: calc(100% - 64px - 24px - 20px);
                margin: 88px 0 0 162px;
            }
        }
    }
</style>
